import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Check } from 'lucide-react';
export function HeroSection() {
  return <section className="relative pt-32 pb-16 lg:pt-40 lg:pb-24 overflow-hidden bg-[#fffbf5]" data-id="element-73">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-74">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-75">
          <h1 className="text-5xl sm:text-6xl lg:text-[5.5rem] font-extrabold text-slate-950 leading-[1.05] mb-6 tracking-tighter" data-id="element-76">
            Slim oefenen, écht begrijpen.
            <br className="hidden lg:block" data-id="element-77" />
            <span className="text-orange-500" data-id="element-78">Adaptief leren</span> voor groep
            6, 7 en 8.
          </h1>

          <p className="text-lg md:text-xl text-slate-600 mb-10 leading-relaxed max-w-2xl mx-auto" data-id="element-79">
            Meester djay is het intelligente leerplatform dat zich aanpast aan
            het niveau van elk kind. Van rekenen en taal tot spelling en
            topografie. Precies wat ze nodig hebben, op het juiste moment.
          </p>

          <div className="flex flex-col sm:flex-row justify-center gap-4 mb-12" data-id="element-80">
            <a href="https://demo.meesterdjay.nl" target="_blank" rel="noopener noreferrer" className="inline-flex justify-center items-center gap-2 bg-orange-500 hover:bg-orange-600 text-white px-8 py-3.5 rounded-lg font-bold text-base transition-colors" data-id="element-81">
              Probeer de Demo
              <ArrowRight className="w-4 h-4" data-id="element-82" />
            </a>
            <a href="#investeerders" className="inline-flex justify-center items-center gap-2 bg-white hover:bg-slate-50 text-slate-900 border border-slate-200 px-8 py-3.5 rounded-lg font-bold text-base transition-colors shadow-sm" data-id="element-83">
              Investeringsvisie
            </a>
          </div>

          {/* Trust Indicators */}
          <div className="flex flex-wrap justify-center items-center gap-x-8 gap-y-4 text-sm font-bold text-slate-500 mb-16" data-id="element-84">
            <span className="flex items-center gap-2" data-id="element-85">
              <Check className="w-4 h-4 text-orange-500" data-id="element-86" />
              10 Vakken
            </span>
            <span className="flex items-center gap-2" data-id="element-87">
              <Check className="w-4 h-4 text-orange-500" data-id="element-88" />
              16 Niveaus
            </span>
            <span className="flex items-center gap-2" data-id="element-89">
              <Check className="w-4 h-4 text-orange-500" data-id="element-90" />
              100+ Vaardigheden
            </span>
          </div>

          {/* Hero Image Mockup */}
          <motion.div initial={{
          opacity: 0,
          y: 40
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative max-w-4xl mx-auto" data-id="element-91">
            {/* Glow effect */}
            <div className="absolute -inset-4 bg-orange-200/40 blur-3xl rounded-[3rem] -z-10" data-id="element-92" />

            <div className="relative rounded-2xl overflow-hidden shadow-2xl border border-slate-200/50 bg-white" data-id="element-93">
              {/* Browser-like header */}
              <div className="h-10 bg-slate-50 border-b border-slate-100 flex items-center px-4 gap-2" data-id="element-94">
                <div className="flex gap-1.5" data-id="element-95">
                  <div className="w-3 h-3 rounded-full bg-rose-400" data-id="element-96" />
                  <div className="w-3 h-3 rounded-full bg-amber-400" data-id="element-97" />
                  <div className="w-3 h-3 rounded-full bg-emerald-400" data-id="element-98" />
                </div>
              </div>
              <img src="https://cdn.magicpatterns.com/uploads/2f7YxgpSwhWJqDWkWrorYC/screencapture-demo-meesterdjay-nl-2026-04-01-11_08_53.png" alt="Meester djay leerling dashboard" className="w-full h-auto object-cover" loading="lazy" data-id="element-99" />
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}